/**
 * Created by Jie Gao on 03/01/2020.
 */



import ("pixi.js");
declare global {
    interface Window {
        PIXI: any;
    }
}
import * as PIXI from "pixi.js";

window.PIXI = PIXI;

import 'pixi-spine';

import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {GoldenGoblins} from "./game/GoldenGoblins";
import {GGIntroConfig} from "./game/intro/GGIntroConfig";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";

require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomEase.js");

declare global {
    interface Window {
        NolimitLauncher: NolimitLauncher;
    }
}
import {EvilGoblinsPromoPanelConfig} from "./game/EvilGoblinsPromoPanelConfig";
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.launch([
    new GoldenGoblins(),
    new NolimitSlotAudio(),
    new SlotKeypad(),
    new NolimitPromotionPlugin(new EvilGoblinsPromoPanelConfig()),
    new NolimitGameIntroPlugin(new GGIntroConfig())
]);